module.exports = __webpack_public_path__ + "static/kutsinta-894427442a45fcde58665c99129986aa.jpg";